import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { AuthService } from 'src/app/nutrigenic/services/auth/auth.service';

@Component({
  selector: 'app-signup-confirmation-dialog',
  templateUrl: './signup-confirmation-dialog.component.html',
  styleUrls: ['./signup-confirmation-dialog.component.scss']
})
export class SignupConfirmationDialogComponent {
  @Input() visible = false;
  @Input() userId = 0;
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(private authService: AuthService) {}

  handleHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  resendMail() {
    this.authService.resendMail({ user_id: this.userId }).subscribe(() => {
      Notify.success('Confirmation mail sent', { position: 'right-top', timeout: 3000 });
    });
  }
}
